window.Cliente = Backbone.Model.extend({

});

window.Clientes = Backbone.Collection.extend({
    model: Cliente
});